import { PublicCourseDetails } from '@/jbi-shared/dto/jtms-public-course.dtos';
import {
  CourseDetails,
  CreateCourseResponse
} from '@/jbi-shared/dto/jtms.dtos';
import {
  CreateCourseMasterDTO,
  FilteredCoursePayload,
  GetCoursesResponsePayload,
  UpdateCourseApiDTO,
  UpdateCourseTypeApiDTO
} from '@/store/modules/jtms/course/course.types';
import { axios } from './axios';
export const courseApi = {
  getCoursesCountForEachStatus() {
    return axios.get('/courses/status-counts');
  },
  getCourseTypes() {
    return axios.get('/courses/course-types');
  },
  getCourses(params: FilteredCoursePayload) {
    return axios.get<GetCoursesResponsePayload>('/courses', {
      params: {
        ...params
      }
    });
  },
  getCourseDetails(id: number) {
    return axios.get<CourseDetails>(`/courses/${id}`);
  },

  getDefaultCourseLevelAttributes() {
    return axios.get(`/group-level-attributes/default/course`);
  },

  getRequiredPublicCourseLevelAttributes() {
    return axios.get(`/group-level-attributes/required/course`);
  },

  createNewCourse(payload: CreateCourseMasterDTO) {
    return axios.post<CreateCourseResponse>('/courses', payload);
  },

  createDraftCourse(payload: CreateCourseMasterDTO) {
    return axios.post<CreateCourseResponse>('/courses/create-draft', payload);
  },

  updateCourse(payload: UpdateCourseApiDTO) {
    return axios.put(`/courses/${payload.courseId}`, payload);
  },

  updateCourseType(payload: UpdateCourseTypeApiDTO) {
    return axios.put(`/courses/${payload.courseId}/course-type`, {
      courseTypeId: payload.courseTypeId
    });
  },

  getCourseBySlug(slug: string) {
    return axios.get(`/short-courses/${slug}`);
  },

  getFullCourseDetailsBySlug(slug: string) {
    const URL = `/short-courses/${slug}?view=FULL`;
    return axios.get<PublicCourseDetails>(URL);
  }
};
